<script lang="ts">
  import {onMount} from 'svelte';
  import {renderer} from '@/store';
  import {VideoService, AnimationService, ProjectService} from '@/services';
  import {getTotalDuration} from '../../store/project';
  import AnimationController, {
    animationPlayerInstance,
    attachProductionTimelinePlaythrough
  } from '../../components/animations/AnimationController.svelte';
  import {AnimationPlayerEvents} from '../../services/animation/timeline-player/animation-timeline-player';
  import PreviewStyles from '../../components/preview-styles/PreviewStyles.svelte';
  export let projectId: number;
  let container: HTMLElement;
  let projectService = new ProjectService();
  let animationService = new AnimationService();
  animationService.forceCaptureEndpoint(); // This tells the timeline to fire something on callback completed
  let videoService = new VideoService();
  onMount(async () => {
    console.log('[RENDERER] Fetching project');
    animationPlayerInstance.setProductionRunthrough(true);

    const project = await projectService.fetchSingle(projectId);
    console.log('[RENDERER] Project fetched', project);
    const totalDuration = getTotalDuration(project.sentences);
    console.log('[RENDERER] Total duration', totalDuration);
    const node = animationService.getDom();
    container.append(node);
    console.log('[RENDERER] Building template');
    await animationService.buildTemplate(project.template, false, true);
    console.log('[RENDERER] done. Setting total duration to:', totalDuration);
    animationService.setTotalDuration(totalDuration);
    console.log('[RENDERER] Preparing sermonclip for production');
    await animationService.prepareSermonclipForProduction();
    console.log('[RENDERER] Building transcription animation from template');

    const textAnimation = project.metadata.textAnimation;
    console.log('[Renderer Text Animation]', textAnimation);
    animationService.buildTranscriptionAnimationData(
      project.video.transcription,
      project.sentences,
      project.video.delays,
      textAnimation
    );
    console.log('[RENDERER] Setting metadata', project.metadata);
    animationService.setMetaData(project.metadata);
    animationService.rebuildForRender();
    console.log('[RENDERER] Initializing loaders');
    console.log('[RENDERER] Adjusting display...');
    animationService.adjustDisplay(true);
    console.log('[RENDERER] setting timeout for building animations...');
    setTimeout(() => {
      animationService.buildAnimations(true, () => {
        console.log('[RENDERER] Setup Production run...');
        setTimeout(() => {
          console.log('[RENDERER] Running production...');
          attachProductionTimelinePlaythrough();

          animationService.runProduction();
        }, 2000);
      });
    }, 2000);
  });
</script>

<PreviewStyles />
<AnimationController />
<div bind:this={container} />
